/* code.icon.svg.js */

"use strict";
module.exports = {
    icon: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="foreground-gl" d="M3 4L11 9.5L3 15" stroke="#4d4d4d" stroke-width="2.5" stroke-linejoin="bevel"/>
        <path class="foreground-gl" d="M11.7058 19.5H20.7058" stroke="#4d4d4d" stroke-width="2.5"/>
    </svg>
`,
};
